import React, { useCallback, useMemo, useState } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import moment from 'moment';

// HELPERS
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// VARIABLES
const TODAY = new Date();

// MAIN COMPONENT
const DateSold = props => {

  // CONTEXT
  const { values, setFieldValue } = useFormikContext() || {};
  const { isAdd } = useRecordView();

  // STATE
  const [ editMode, setEditMode ] = useState(false);

  // MEMOS
  const {
    sales_time
  } = useMemo(
    () => values || {},
    [values]
  )

  // CALLBACKS
  const handleDateChangeClick = useCallback(
    () => {
      setEditMode(!editMode);
      setFieldValue(`sales_time`, '');
    },
    [editMode, setEditMode, setFieldValue]
  )

  // RENDER
  return isAdd ? editMode ? (
    <Form.Date
      name="sales_time"
      label="Date Sold"
      className="me-2"
      input={{ 
        append: <Button.Cancel fullWidth={false} outline onClick={handleDateChangeClick} />
      }}
      required
      maxDate={TODAY}
    />
  ) : (
    <Form.PlainText
      label="Date Sold"
      hidden={editMode}
      value={
        <label>
          {`${moment(TODAY).format('MM/DD/YYYY')} at ${moment(TODAY).format('h:mm A')} `}
          <a className="middle" role="button" tabIndex={0} onClick={handleDateChangeClick}>
            Change
          </a>
        </label>
      }
      {...props}
    />
  ) : (
    <Form.PlainText
      label="Date Sold"
      value={`${moment(sales_time).format('MM/DD/YYYY')} at ${moment(sales_time).format('h:mm A')}`}
      {...props}
    />
  )
}

// EXPORT
export default DateSold
